/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScrimmageRequestAcceptRejectEnum } from './ScrimmageRequestAcceptRejectEnum';
import {
    ScrimmageRequestAcceptRejectEnumFromJSON,
    ScrimmageRequestAcceptRejectEnumFromJSONTyped,
    ScrimmageRequestAcceptRejectEnumToJSON,
} from './ScrimmageRequestAcceptRejectEnum';

/**
 * 
 * @export
 * @interface TeamProfilePrivateRequest
 */
export interface TeamProfilePrivateRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamProfilePrivateRequest
     */
    quote?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamProfilePrivateRequest
     */
    biography?: string;
    /**
     * 
     * @type {ScrimmageRequestAcceptRejectEnum}
     * @memberof TeamProfilePrivateRequest
     */
    auto_accept_reject_ranked?: ScrimmageRequestAcceptRejectEnum;
    /**
     * 
     * @type {ScrimmageRequestAcceptRejectEnum}
     * @memberof TeamProfilePrivateRequest
     */
    auto_accept_reject_unranked?: ScrimmageRequestAcceptRejectEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof TeamProfilePrivateRequest
     */
    eligible_for?: Array<number>;
}

/**
 * Check if a given object implements the TeamProfilePrivateRequest interface.
 */
export function instanceOfTeamProfilePrivateRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TeamProfilePrivateRequestFromJSON(json: any): TeamProfilePrivateRequest {
    return TeamProfilePrivateRequestFromJSONTyped(json, false);
}

export function TeamProfilePrivateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamProfilePrivateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quote': !exists(json, 'quote') ? undefined : json['quote'],
        'biography': !exists(json, 'biography') ? undefined : json['biography'],
        'auto_accept_reject_ranked': !exists(json, 'auto_accept_reject_ranked') ? undefined : ScrimmageRequestAcceptRejectEnumFromJSON(json['auto_accept_reject_ranked']),
        'auto_accept_reject_unranked': !exists(json, 'auto_accept_reject_unranked') ? undefined : ScrimmageRequestAcceptRejectEnumFromJSON(json['auto_accept_reject_unranked']),
        'eligible_for': !exists(json, 'eligible_for') ? undefined : json['eligible_for'],
    };
}

export function TeamProfilePrivateRequestToJSON(value?: TeamProfilePrivateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'quote': value.quote,
        'biography': value.biography,
        'auto_accept_reject_ranked': ScrimmageRequestAcceptRejectEnumToJSON(value.auto_accept_reject_ranked),
        'auto_accept_reject_unranked': ScrimmageRequestAcceptRejectEnumToJSON(value.auto_accept_reject_unranked),
        'eligible_for': value.eligible_for,
    };
}

